import React, { useEffect, useState } from "react";
import ProfileImg from "../../assets/img/profileImg.svg";
import EmployeImg from "../../assets/img/experianCheck.svg";
import Flatmates from "../../assets/img/Flatmates.svg";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import bagImg from "../../assets/img/employeSVG.svg";
import Guarantors from "../../assets/img/Guarantors.svg";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import ExchangeIcon from "../../assets/img/exchange-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import {
  getIdentityDetails,
  haveValue,
  isDefaulter,
} from "../../helper/common";
import constants from "../../Utils/constants";
import VectorIcon2 from "../../assets/img/icon-report.svg";
import VectorIcon3 from "../../assets/img/material-symbols.svg";
import UserBack from "../../assets/img/arrow-left-02-round.svg";
import { useNavigate } from "react-router-dom";

import FlatmateModal from "../TenantDetails/FlatmateModal";
const TenantDetailsHeader = (props) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const [showModal, setShowModal] = useState(false);
  const { _t } = useTranslator();
  const {
    user = {},
    forensicAnalysis = null,
    userIncome = {},
    setShowDefaulterCheck,
    totalIncomeModal,
    setTotalIncomeModal,
    fullinfo,
    setUpdateSourceObj,
    handleUpdateSource,
    showReportIcons = true,
    updateSourceObj,
  } = props;

  const experianData =
    user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

  const [kycDetails, setKycDetails] = useState(null);
  useEffect(() => {
    setKycDetails(getIdentityDetails(user, user?.onfido_user_kyc));
  }, []);

  const getEmploymentStatus = () => {
    if (user?.employment_status == constants.employed) {
      return _t("employed");
    }
    if (user?.employment_status == constants.self_employed) {
      return _t("selfEmployed");
    }
    if (user?.employment_status == constants.student) {
      return _t("student");
    }
    if (user?.employment_status == constants.unemployed) {
      return _t("unemployed");
    }
    if (user?.employment_status == constants.retired) {
      return _t("retired");
    }
    if (user?.employment_status == constants.public_servant) {
      return _t("publicServant");
    }
  };

  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  const handleChangeSource = () => {
    handleUpdateSource();
    setUpdateSourceObj({
      _id: userIncome?.all_sources?._id,
      all_sources: userIncome?.all_sources,
      current_selected: userIncome?.source,
      type: "tenant",
    });
  };

  const handleNavigateReport = () => {
    const sharedId =
      queryParameters.get("agencylink") ||
      queryParameters.get("sharedprofileid");
    const queryParam = haveValue(queryParameters.get("agencylink"))
      ? `agencylink=${sharedId}`
      : `sharedprofileid=${sharedId}`;
    window.open(
      `https://${process.env.REACT_APP_URL_NAME}/generatedReport/${sharedId}?${queryParam}`,
      "_blank"
    );
  };

  return (
    <>
      <div className={`profileinfo ${scrolled ? "scrolled" : ""}`}>
        <div className="row">
          <div className="col">
            <div className="profileheading">
              <div className="row">
                {showReportIcons && (
                  <div
                    className="col-1 cursor-pointer"
                    onClick={() => navigate("/profile-request")}
                  >
                    <div className="userfixed_css userback_css d-flex align-items-center justify-content-center">
                      <div>
                        <p className="Profileheading_change1">
                          <img
                            src={UserBack}
                            alt="Vector Icon"
                            className="vactorImg"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-1 pl-0">
                  <div className="userfixed_css d-flex align-items-center justify-content-center">
                    <div>
                      <p className="Profileheading_change">
                        {user?.fname && user?.fname.charAt(0).toUpperCase()}
                        {user?.lname && user?.lname.charAt(0).toUpperCase()}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="d-flex gap-2">
                    <img
                      src={ProfileImg}
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <div>
                      <p className="Profileheading_change mb-2">
                        {kycDetails?.type === "dni"
                          ? _t(
                              "dniNieDetails",
                              "On new Skor Lite tenantDetails page header"
                            )
                          : _t("passport")}
                      </p>
                      <p className="Profileheading_change2">
                        {kycDetails?.value}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="d-flex gap-2">
                    <img src={bagImg} alt="Vector Icon" className="vactorImg" />
                    <div>
                      <p className="Profileheading_change mb-2">
                        {_t("employmentStatus")}
                      </p>
                      <p className="Profileheading_change2">
                        {getEmploymentStatus()}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="d-flex gap-2">
                    <img
                      src={EmployeImg}
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <div
                      className="cursor-pointer"
                      onClick={(e) => setShowDefaulterCheck(true)}
                    >
                      <p className="Profileheading_change mb-2">
                        {_t("experianCheck")}
                      </p>
                      <div className="d-flex align-items-center gap-2">
                        <p className="Profileheading_change2">
                          {_t(isDefaulter(experianData))}
                        </p>
                        {showReportIcons && (
                          <img
                            className="Imagerutate ImageSizeSet"
                            src={VectorIcon}
                            alt="Vector Icon"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="d-flex gap-2 cursor-pointer"
                    onClick={() => setTotalIncomeModal(true)}
                  >
                    <img
                      src={Guarantors}
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <div>
                      <p className="Profileheading_change mb-2">
                        {_t("guarantors")}
                      </p>
                      <div className="d-flex align-items-center gap-2">
                        <p className="Profileheading_change2">
                          {user?.gurantor_id?.length ?? 0}
                        </p>
                        {showReportIcons && (
                          <img
                            className="Imagerutate ImageSizeSet"
                            src={VectorIcon}
                            alt="Vector Icon"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="d-flex gap-2 cursor-pointer"
                    onClick={() => setShowModal(true)}
                  >
                    <img
                      src={Flatmates}
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <div>
                      <p className="Profileheading_change mb-2">
                        {_t("flatmates")}
                      </p>
                      <div className="d-flex align-items-center gap-2">
                        <p className="Profileheading_change2">
                          {user?.sharers?.length ?? 0}
                        </p>
                        {showReportIcons && (
                          <img
                            className="Imagerutate ImageSizeSet"
                            src={VectorIcon}
                            alt="Vector Icon"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-2">
            <div className="col incomeDiv">
              <div className="d-flex gap-2">
                <div className="w-100">
                  <p className="Profileheading_change mb-2">
                    {_t(
                      "selectedAnnualIncome",
                      "On new Skor Lite tenantDetails page header"
                    )}
                  </p>
                  <div className="d-flex align-items-center justify-content-between gap-4">
                    <div className="d-flex align-items-center">
                      <p className="Profileheading_change3">
                        €{userIncome?.amount}
                      </p>
                      {showReportIcons &&
                        haveValue(userIncome?.all_sources) && (
                          <div className="re-do-icon-wrapper header-icon-wrapper">
                            <img
                              src={ExchangeIcon}
                              alt=""
                              onClick={handleChangeSource}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        )}
                    </div>
                    <ul className="infodorpdown summarydropdum position-relative">
                      <li>
                        <img
                          src={moreInfoimg}
                          alt="Vector Icon"
                          className="vactorImg vactorImg1"
                        />
                      </li>
                      <ul className="tooltip">{_t(userIncome?.source)}</ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showReportIcons && (
            <>
              <div className="col-2">
                <div className="col-auto gap-4">
                  <div
                    onClick={() =>
                      window.open(
                        `${process.env.REACT_APP_SKOR_LITE_URL}${currentLang}/report/${user?._id}`,
                        "_blank"
                      )
                    }
                    className="reportbox d-flex gap-2 cursor-pointer mb-2"
                  >
                    <img src={VectorIcon2} alt="Vector Icon" />
                    <p>{_t("viewDetails", "On new Skor Lite page")}</p>
                  </div>
                  <div
                    className="reportbox bgColorChange d-flex gap-2 cursor-pointer"
                    onClick={handleNavigateReport}
                  >
                    <img src={VectorIcon3} alt="Vector Icon" />
                    <p>{_t("generateReport")}</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <FlatmateModal
        show={showModal}
        onHide={() => setShowModal(false)}
        user={user}
        _t={_t}
        sharerData={fullinfo?.sharersData ?? []}
      />
    </>
  );
};

export default TenantDetailsHeader;
